'use strict';

/**
 * LEG-609. Client copy of the PayPal credit-messaging script
 * paypal_credit_messaging/cartridge/static/default/js/dynamicPriceUpdate.js
 * (vendor original SHA-256 29fa7a0f8c6dfb61..., 314 bytes, unchanged since 2023-04-27).
 *
 * Keeps the PayPal "Pay in 4 / Pay Monthly" amount in step with the selected
 * variant and quantity. A master with an unselected attribute carries a price
 * RANGE and a tiered price book carries tiers, so there is no single selling
 * price yet: leave the amount already shown. An item with no usable price
 * writes 0, which PayPal renders as its generic "Buy now, pay later." text
 * rather than financing terms for a different item. PayPal accepts an amount
 * with 0 to 2 decimal places, so the product is rounded.
 */
$('body').on('product:afterAttributeSelect', function (e, response) {
    var product = response && response.data && response.data.product;
    var container = response && response.container && response.container[0];
    var creditMessage = container && container.querySelector('.js_credit_message_pdp');

    if (!creditMessage) {
        return;
    }

    var sales = product && product.price && product.price.sales;

    if (!sales) {
        return;
    }

    var amount = Math.round(parseFloat(sales.value) * parseFloat(product.selectedQuantity) * 100) / 100;

    creditMessage.setAttribute('data-pp-amount', isNaN(amount) ? 0 : amount);
});
